import styled from 'styled-components';
import { Paragraf } from '../Styled';
import SVGVECTOR from '../images/web_bg_big_right.png';
import SVGLEFT from '../images/web_bg_big_left.png';

export const WebUdviklingPage = styled.div`
  background-repeat: no-repeat;
  background-position: right top;
  background-attachment: scroll;
`;

export const WebHero = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  min-height: 100vh;
  align-items: space-between;
  background: rgb(14, 91, 204);
  background: linear-gradient(
    158deg,
    rgba(14, 91, 204, 1) 0%,
    rgba(9, 179, 195, 1) 44%,
    rgba(89, 203, 180, 1) 100%
  );
`;

export const WebHeroMiddle = styled.div`
  margin: auto;
  width: 100%;
  max-width: 1200px;
  display: flex;
  flex-direction: row;
  position: relative;
  z-index: 3;
  justify-content: space-between;
  align-items: center;
  height: max-content;
  & > div {
    width: 45%;
    flex-grow: 0;
    flex-shrink: 0;
    justify-content: flex-start;
  }
`;

export const WebHeroImg = styled.img`
  display: block;
  width: 100%;
  margin: auto;
`;

export const WebHeroTitle = styled.h1`
  color: black;
  width: max-content;
  max-width: 100%;
  font-size: 3rem;
  padding: 5px 0;
  margin: 0;
  color: ${({ theme }) => theme.mainColors.hvid};
`;

export const WebHeroDes = styled.h2`
  width: max-content;
  color: black;
  font-size: 1.5rem;
  text-align: left;
  transparancy: 0.8;
  margin: 0 0 25px;
  max-width: 100%;

  color: ${({ theme }) => theme.mainColors.hvid};
`;

export const WebCtaUpInner = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  row-gap: 10px;
`;

export const WebParaCtaUp = styled(Paragraf)`
  text-align: center;
  max-width: 450px;
  margin: 0 0 10px;
`;


export const UpperSection = styled.div`
  background-image: url(${SVGVECTOR});
  background-repeat: no-repeat;
  padding: 50px 0;
`;

export const DownSection = styled.div`
  background-image: url(${SVGLEFT});
  background-repeat: no-repeat;
  padding: 50px 0;
`;
